import { actionType } from "../actions/kjoretoyMerkerActions";
import * as reducerUtils from "../utils/reducerUtils";

const INITIAL_STATE = [];
const kjoretoyMerkerReducer = (state = INITIAL_STATE, action) =>
  reducerUtils.CreateNewReducer(state, action, actionType);

export default kjoretoyMerkerReducer;
